export enum SessionItems{
thirdpartylist_filterForm = 'thirdpartylist_filterForm',
thirdPartylist_pageIndex = 'thirdPartylist_pageIndex',
thirdPartylist_pageSize = 'thirdPartylist_pageSize',
thirdPartylist_sortOrder = 'thirdPartylist_sortOrder',
thirdPartylist_sortBy = 'thirdPartylist_sortBy',

}